var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"size":"small","title":"报文处理"}},[_c('searchE',{on:{"handleSearch":_vm.handleSubmit}}),_c('tableE',{ref:"processTable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }